export const getDetailPageUrl = (typology: string, orderId: string, externalId?: string): string => {
  let detailPageUrl = ''

  if (typology === 'discount') {
    detailPageUrl = `#/shop/direct/discount/${orderId}`
  } else if (typology === 'giftCard') {
    detailPageUrl = `#/shop/direct/giftCard/${orderId}`
  } else if (typology === 'goodAndService') {
    detailPageUrl = `#/shop/direct/goodAndService/${orderId}`
  } else if (typology === 'voucher') {
    detailPageUrl = `#/shop/direct/voucher/${orderId}`
  } else if (typology === 'moneyTransfer') {
    if (externalId === 'moneyTransfer|FONDO_SANITARIO') {
      detailPageUrl = `#/shop/transfer/fondosalute/${orderId}`
    } else if (externalId === 'moneyTransfer|PREVIDENZA_COMPLEMENTARE') {
      detailPageUrl = `#/shop/transfer/fondopensione/${orderId}`
    }
  } else if (typology === 'refund') {
    detailPageUrl = `#/shop/refund/${orderId}`
  }

  return detailPageUrl
}
